// extracted by mini-css-extract-plugin
module.exports = {"ticketError":"Ticket_ticketError__3xXKx","actionError":"Ticket_actionError__3cWv5","loading":"Ticket_loading__3wRyZ"};